import { render, staticRenderFns } from "./TranslationEditModal.vue?vue&type=template&id=3e4cc014"
import script from "./TranslationEditModal.vue?vue&type=script&lang=ts"
export * from "./TranslationEditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e4cc014')) {
      api.createRecord('3e4cc014', component.options)
    } else {
      api.reload('3e4cc014', component.options)
    }
    module.hot.accept("./TranslationEditModal.vue?vue&type=template&id=3e4cc014", function () {
      api.rerender('3e4cc014', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/TranslationEditModal.vue"
export default component.exports